(() => {
  if (window.EfesProductSliderLoaded) return;
  window.EfesProductSliderLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initSlider = (root) => {
    if (!root || root.dataset.efesSliderReady === 'true') return;

    const track = root.querySelector('[data-efes-slider-track]');
    const previousButton = root.querySelector('[data-efes-slider-prev]');
    const nextButton = root.querySelector('[data-efes-slider-next]');

    if (!track || !previousButton || !nextButton) return;

    root.dataset.efesSliderReady = 'true';

    const getStep = () => {
      const card = track.querySelector('.efes-product-card');
      if (!card) return track.clientWidth;

      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

      return card.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previousButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
    };

    const move = (direction) => {
      track.scrollBy({
        left: getStep() * direction,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    previousButton.addEventListener('click', () => move(-1));
    nextButton.addEventListener('click', () => move(1));

    track.addEventListener('scroll', updateControls, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    const resizeObserver = new ResizeObserver(updateControls);
    resizeObserver.observe(track);

    updateControls();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-efes-product-slider]')) {
      initSlider(scope);
    }

    scope.querySelectorAll?.('[data-efes-product-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
